<p-card [header]="person.fullName" [subheader]="person.updatedDate">
  <div class="table-responsive">
  <table class="table table-sm table-striped">
    <tbody>
      <tr *ngIf="person.iacmacNumber">
        <td style="width: 15%;" class="font-bold">Номер МАКМАХ</td>
        <td style="width: 35%;">
          <span class="badge badge-success">
            {{ person.iacmacNumber }}
          </span>
        </td>
        <td style="width: 15%;" class="font-bold"> Дата регистрации </td>
        <td style="width: 35%;">{{ person.iacmacDate }}</td>
      </tr>
      <tr>
        <td style="width: 15%;" class="font-bold">
          Город
        </td>
        <td  style="width: 35%;">
          {{ person.city }}, {{ person.region}} , {{ person.country }}
        </td>
        <td style="width: 15%;" class="font-bold">
          Дата рождения
        </td>
        <td style="width: 35%;">
          {{ person.dateBirth }}
        </td>
      </tr>
      <tr *ngIf="person.specialities.length > 0">
        <td style="width: 15%;" class="font-bold">Специальность</td>
        <td style="width: 35%;" colspan="3">{{ person.specialitiesString }}</td>
      </tr>
      <tr *ngIf="person.workplace || person.position">
        <td style="width: 15%;" class="font-bold">Место работы</td>
        <td style="width: 35%;">{{ person.workplace }}</td>
        <td style="width: 15%;" class="font-bold">Должность</td>
        <td style="width: 35%;">{{ person.position }}</td>
      </tr>
      <tr *ngIf="person.scienceDegree || person.scienceStatus">
        <td style="width: 15%;" class="font-bold">Степень</td>
        <td style="width: 35%;">{{ person.scienceDegree?.name }}</td>
        <td style="width: 15%;" class="font-bold">Звание</td>
        <td style="width: 35%;">{{ person.scienceStatus?.name }}</td>
      </tr>
      <tr *ngIf="person.emails.length > 0 || person.phones.length > 0">
        <td style="width: 15%;" class="font-bold">Email</td>
        <td  style="width: 35%;">
          <ul class="list-unstyled" *ngFor="let email of person.emails">
            <li class="mt-2"><i class="pi pi-copy mr-2" style="cursor: pointer;" ngxClipboard [cbContent]="email"></i>{{email}}</li>
          </ul>
        </td>
        <td style="width: 15%;" class="font-bold">Телефон</td>
        <td style="width: 35%;">
          <ul class="list-unstyled" *ngFor="let phone of person.phones">
            <li><i class="pi pi-copy mr-2" style="cursor: pointer;" ngxClipboard [cbContent]="phone"></i>{{phone}}</li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  <div class="alert alert-danger" role="alert" *ngIf="person.info">
    {{ person.info }}
  </div>
  <!-- <dl class="row" *ngIf="person.iacmacNumber">
    <dt class="col-sm-2">Номер МАКМАХ</dt>
    <dd class="col-sm-4">
      <span class="badge badge-success">
        {{ person.iacmacNumber }}
      </span>
    </dd>
    <dt class="col-sm-2">Дата регистрации</dt>
    <dd class="col-sm-4">{{ person.iacmacDate }}</dd>
  </dl>
  <dl class="row">
    <dt class="col-sm-2" *ngIf="person.dateBirth">Дата рождения</dt>
    <dd class="col-sm-10" *ngIf="person.dateBirth">{{ person.dateBirth }}</dd>
    <dt class="col-sm-2">Город</dt>
    <dd class="col-sm-10">{{ person.city }}, {{ person.region}} , {{ person.country }}</dd>
  </dl>
  <dl class="row">
    <dt class="col-sm-2" *ngIf="person.workplace">Место работы</dt>
    <dd class="col-sm-4" *ngIf="person.workplace">{{ person.workplace }}</dd>
    <dt class="col-sm-2" *ngIf="person.position">Должность</dt>
    <dd class="col-sm-4" *ngIf="person.position">{{ person.position }}</dd>
  </dl>
  <dl class="row">
    <dt class="col-sm-2" *ngIf="person.scienceDegree?.name">Научная степень</dt>
    <dd class="col-sm-4" *ngIf="person.scienceDegree?.name">{{ person.scienceDegree?.name }}</dd>
    <dt class="col-sm-2" *ngIf="person.scienceStatus?.name">Научное звание</dt>
    <dd class="col-sm-4" *ngIf="person.scienceStatus?.name">{{ person.scienceStatus?.name }}</dd>
  </dl>
  <dl class="row" *ngIf="person.specialities.length > 0">
    <dt class="col-sm-2">Специальность</dt>
    <dd class="col-sm-10">{{ person.specialitiesString }}</dd>
  </dl>
  <dl class="row">
    <dt class="col-sm-2" *ngIf="person.isHasEmail">Email</dt>
    <dd class="col-sm-4" *ngIf="person.isHasEmail">
      <ul class="list-unstyled" *ngFor="let email of person.emails">
        <li><i class="pi pi-copy mr-2" style="cursor: pointer;" ngxClipboard [cbContent]="email"></i>{{email}}</li>
      </ul>
    </dd>
    <dt class="col-sm-2" *ngIf="person.isHasPhone">Телефон</dt>
    <dd class="col-sm-4" *ngIf="person.isHasPhone">
      <ul class="list-unstyled" *ngFor="let phone of person.phones">
        <li><i class="pi pi-copy mr-2" style="cursor: pointer;" ngxClipboard [cbContent]="phone"></i>{{phone}}</li>
      </ul>
    </dd>
  </dl> -->

  <!-- <div class="alert alert-primary" role="alert" *ngIf="person.info">
    {{ person.info }}
  </div> -->

  <ng-template pTemplate="footer" *ngIf="!isReadOnly">
    <p-button label="Редактировать" styleClass="p-button-warning mr-2 mt-3" (click)="onEdit()"></p-button>
    <!-- <p-button *ngIf="person.iacmacNumber" label="Изменить номер МАКМАХ" styleClass="p-button-warning mr-2" (click)="onEditIacmac()"></p-button> -->
    <!-- <p-button *ngIf="!person.iacmacNumber" label="Присвоить номер МАКМАХ" styleClass="p-button-warning mr-2" (click)="onNewIacmac()"></p-button> -->
    <p-button *ngIf="isDelete" label="Удалить" styleClass="p-button-danger mt-3" (click)="onDelete()"></p-button>
  </ng-template>
</p-card>
